// Relocate a mapped Report Builder extract to its original transcript
// segment(s) (SCRIBE-07 back-link). The extract's exact text is stored at
// map-time (`ReportModuleExtractSource.text`) but no offset/segment id is —
// an offset would go stale the moment the transcript is re-diarized or
// edited. This is the fuzzy fallback for when an exact substring match
// against the live segments fails; callers should always try an exact match
// first (cheap, zero false positives) and only fall back to this.
//
// Shares its scoring with the OCR-citation matcher
// (`components/FilePreview/utils/matchSnippetToLines.ts`) via
// `utils/wordOverlapMatch.ts` — same "paraphrased/edited text, no exact
// position stored" problem, different granularity (transcript segments
// instead of OCR lines).
import { matchSnippetToBlocks } from "@/utils/wordOverlapMatch";

/**
 * Find the transcript segment indices an extract's text most likely came
 * from, by content-word overlap. Returns sorted indices, or `null` when
 * nothing clears the bar — callers should land on the tab without
 * highlighting anything in that case, not guess.
 */
export const matchSnippetToSegments = (
  segments: string[],
  snippet: string
): number[] | null => matchSnippetToBlocks(segments, snippet);
